import {
  ContentResponse,
  ID,
  StoreExecutorTable,
  UploadContentRequest,
} from "@project/shared-types";
import { apiUploadFile } from "../../../api/apiClient";

export const UploadContentApi = async (
  file: File,
  table_id: ID,
  table_type: StoreExecutorTable,
  onProgress?: (percent: number) => void,
  folder_name: string = "content"
) => {
  //Вкратце, этот код представляет собой функцию, которая загружает файл в определённую конечную точку с помощью вызова API и возвращает ответ от этого вызова API.
  const response = await apiUploadFile<ContentResponse>(
    "content/upload/",
    file,
    {
      table_id: table_id,
      table_type: table_type,
      folder_name: folder_name,
    } as UploadContentRequest,
    undefined,
    onProgress
  );
  return response;
};
